<template>
<v-card flat>
          <v-toolbar flat color="grey lighten-3">
            <v-toolbar-title>{{ $t('app.label.jobList') }}</v-toolbar-title>            
          </v-toolbar>
    <ViewBar :hidden="true"></ViewBar>
    <v-container id="stats" fluid>
      <v-layout align-space-around justify-start column>
        <v-card flat>
          <v-container>
            <v-layout column wrap justify-space-between>
          <v-flex pb-2 v-for="job in jobs" :key="job.id" :id="`job-${job.id}`">
            <JobCard :job="job"></JobCard>
          </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import JobCard from "../components/JobCard"
import ViewBar from "../components/viewbar/ViewBar"

import { mapState, mapActions, mapMutations } from "vuex";

export default {
  namespaced: true,
  components: {
    JobCard,
    ViewBar,
  },
  computed: {
    ...mapState("jobs", ["jobs"]),
    ...mapState(["project"]),
  },
  methods: {
    ...mapActions("jobs", ["fetchJobs"]),
    ...mapMutations("jobs", ["setLastJobDisplayTimestamp"])
  },
  mounted() {
    this.fetchJobs()
    this.setLastJobDisplayTimestamp()
  },
};
</script>
